import { Redirect, Route, Switch } from 'react-router-dom';
import routes from 'routes';

export default function Auth() {
	const getRoutes = (routes: RoutesType[]): any => {
		return routes.map((route: RoutesType, key: any) => {
			if (route.layout === '/auth') {
				return <Route path={route.layout + route.path} component={route.component} key={key} />;
			} else {
				return null;
			}
		});
	};

	return (
		<Switch>
			{getRoutes(routes)}
			<Redirect from='/auth' to='/auth/sign-in' />
		</Switch>
	);
}
